import { Api } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  configs: Api.App.Configs;
};

export function useConfigs() {
  return useQuery<Api.App.Configs>({
    queryKey: [Query.AppKeys['configs']],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/configs`);
      return resp.data.configs;
    },
  });
}
